import { render, staticRenderFns } from "./GiftcardConfirmed.vue?vue&type=template&id=ccaf50e6&scoped=true&"
import script from "./GiftcardConfirmed.vue?vue&type=script&lang=js&"
export * from "./GiftcardConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardConfirmed.vue?vue&type=style&index=0&id=ccaf50e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf50e6",
  null
  
)

export default component.exports